import React from "react";
import PropTypes from "prop-types";
import {Box, Skeleton, Stack} from "@mui/material";

const tableSx = {
    border: "1px solid #eee",
    "& .MuiDataGrid-cell:focus": {
        outline: "none",
    },
};

export const TableSkeleton = ({columns}) => {
    const visibleColumns = columns.filter((column) => !column.hide);

    return (
        <Box sx={tableSx}>
            <Stack spacing={1}>
                <Stack direction="row" spacing={1}>
                    {visibleColumns.map((column) => (
                        <Skeleton
                            key={column.field}
                            variant="rounded"
                            height={32}
                            sx={{
                                flex: column.flex || 1,
                                minWidth: column.minWidth || 80,
                            }}
                        />
                    ))}
                </Stack>

                {[0, 1, 2, 3, 4].map((rowIndex) => (
                    <Stack key={rowIndex} direction="row" spacing={1}>
                        {visibleColumns.map((column) => (
                            <Skeleton
                                key={`${rowIndex}-${column.field}`}
                                variant="rounded"
                                height={36}
                                sx={{
                                    flex: column.flex || 1,
                                    minWidth: column.minWidth || 80,
                                }}
                            />
                        ))}
                    </Stack>
                ))}
            </Stack>
        </Box>
    );
};

TableSkeleton.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            field: PropTypes.string.isRequired,
            flex: PropTypes.number,
            minWidth: PropTypes.number,
            hide: PropTypes.bool,
        })
    ).isRequired,
};
